import { create } from 'zustand'

interface NotificationStore {
    without_seeing: boolean
    without_seeing_total: number
    setWithout_seeing: (without_seeing: boolean) => void
    setWithout_seeing_total:  (without_seeing_total: number) => void
}

export const useNotificationStore = create<NotificationStore>((set) => ({
    without_seeing: false,
    without_seeing_total: 0,
    setWithout_seeing: (without_seeing) => set({ without_seeing }),
    setWithout_seeing_total: (without_seeing_total) => set({ without_seeing_total }),
}))
